export interface IBatchPublishOptions {
  maxMessages: number;
  maxMilliseconds: number;
}

export const DEFAULT_BATCH_PUBLISH_OPTIONS: IBatchPublishOptions = {
  maxMessages: 10,
  maxMilliseconds: 1 * 1000,
};

export interface IPubSubPublisher {
  publish<T, Metadata extends { [key: string]: string }>(
    topic: string,
    data: T,
    metadata?: Metadata
  ): Promise<void>;

  publishBatch<T, Metadata extends { [key: string]: string }>(
    topic: string,
    batchSettings: IBatchPublishOptions
  ): Promise<(data: T, metadata?: Metadata) => Promise<void>>;
}
